import { ThemeType } from "Model/Configuration/ITheme";
import { isNullOrWhiteSpace } from "./String";

export function getOSTheme() {
  const darkThemeMq = window.matchMedia(`(prefers-color-scheme: dark)`);
  return darkThemeMq.matches ? ThemeType.Dark : ThemeType.Light;
}

export function isDarkTheme() {
  return getOSTheme() === ThemeType.Dark;
}

export function isLightTheme() {
  return getOSTheme() === ThemeType.Light;
}

export function getThemeBySetting(type: ThemeType) {
  if (isNullOrWhiteSpace(type) || type === ThemeType.Auto) {
    return getOSTheme();
  }
  return type;
}
